import React, { useMemo } from 'react';

import { Form, Select } from 'antd';

import { InfoTooltip } from '@common/components';
import { Colors } from 'works/legacy/lib/style-helper';
import { SpearfishableGroupsByShiftGapQueryCgResponse } from '@common/graphql/schema';

export const WorkforceGroupSelector = ({
  spearfishableGroupData,
  groupIds,
  setGroupIds,
}: {
  spearfishableGroupData:
    | SpearfishableGroupsByShiftGapQueryCgResponse
    | undefined;
  groupIds: string[];
  setGroupIds: (groupIds: string[]) => void;
}) => {
  const transformedGroupData = useMemo(() => {
    return spearfishableGroupData?.spearfishableGroupsByShiftGap.map(
      (group) => ({
        label: group.name,
        value: group.id,
        disabled: !group.spearfishable,
        name: group.name,
        count: group.count,
      })
    );
  }, [spearfishableGroupData]);

  return (
    <Form.Item
      label={
        <>
          Groups
          <InfoTooltip
            size="sm"
            leftOffset={5}
            iconColor={Colors.elm}
            title="Only available Workers signed into the app will receive a notification."
          />
        </>
      }
      name="groups"
      style={{ fontWeight: 'medium', marginBottom: 24 }}
      required
    >
      <Select
        mode="multiple"
        filterOption={(input, option) =>
          (String(option?.label) ?? '')
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        onChange={(e) => setGroupIds(e as string[])}
        style={{ width: '100%' }}
        showSearch
        value={groupIds}
        notFoundContent={<div>No groups found</div>}
        placeholder="Search available groups"
        optionLabelProp="label"
      >
        {transformedGroupData?.map((group) => (
          <Select.Option
            key={group.value}
            value={group.value}
            label={`${group.name} (${group.count})`}
            disabled={group.disabled}
          >
            <div style={{ display: 'flex' }}>
              {group.name}
              <div className="count-pill">{group.count}</div>
            </div>
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
